module.exports = __webpack_public_path__ + "media/img/apple-icon-76x76-62cc8c0f7eedfc301f7ea3538308821d.png";